import script from "./share.vue?vue&type=script&setup=true&lang=js"
export * from "./share.vue?vue&type=script&setup=true&lang=js"

import "./share.vue?vue&type=style&index=0&id=11eaf216&scoped=true&lang=css"

import exportComponent from "F:\\Vuedemo\\element-便签\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11eaf216"]])

export default __exports__